"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpoints = void 0;
const api_1 = __importDefault(require("./api"));
const Services = Object.assign({}, api_1.default);
// @ts-ignore
function keyObj(obj) {
    // @ts-ignore
    return Object.keys(obj).reduce((acc, curr) => {
        // @ts-ignore
        acc[curr] = curr;
        return acc;
    }, {});
}
// @ts-ignore
exports.endpoints = keyObj(Services);
exports.default = Services;
